import React from 'react';
import './Testimonials.css'; // CSS pour les témoignages

// Données d'exemple pour les témoignages (À REMPLACER PAR DE VRAIS AVIS !)
// Pensez à demander la permission avant de publier un avis nominatif.
const testimonialsData = [
  {
    id: 1,
    quote: "Un choix incroyable de fromages affinés à la perfection ! L'accueil est toujours chaleureux et les conseils avisés. Ma fromagerie préférée à L'Isle-Jourdain, sans hésiter.",
    author: "Marie L., Cliente fidèle"
  },
  {
    id: 2,
    quote: "J'ai découvert des pépites grâce à Paul ! Il connaît ses produits sur le bout des doigts et partage sa passion avec enthousiasme. La qualité est irréprochable.",
    author: "Jean-Pierre V."
  },
  {
    id: 3,
    quote: "La boutique est charmante et les plateaux de fromages sont magnifiques et délicieux. Parfait pour épater ses invités ou simplement se faire plaisir. Je recommande vivement !",
    author: "Sophie D., Nouvelle habitante"
  }
  // Ajoutez d'autres témoignages si vous le souhaitez
];

function Testimonials() {
  return (
    // Optionnel: ajouter id="testimonials" si vous voulez un lien direct depuis la navbar
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <h2 className="section-title">Ce que nos clients disent</h2>

        <div className="testimonials-grid">
          {testimonialsData.map(testimonial => (
            <div key={testimonial.id} className="testimonial-card">
              <p className="testimonial-text">"{testimonial.quote}"</p>
              <p className="testimonial-author">- {testimonial.author}</p>
              {/* Optionnel: Ajouter des étoiles de notation ici */}
              {/* <div className="testimonial-rating">★★★★☆</div> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;